// Shared so the panel body and its header cannot drift to different nouns.
export const DEFAULT_PANEL_ENTITY = 'vulnerability';

// Both hosting tables list (application version, vulnerability) pairs from
// opposite ends, so one sentence reads correctly whichever half is fixed.
export const AFFECTED_PACKAGES_COLUMN_DESCRIPTION =
  'The number of packages in this application version affected by this vulnerability; click the panel icon to list them.';
